import React, { useRef, useEffect } from "react";
import { Toast } from "primereact/toast";

interface MessageProps {
  open: boolean; 
  severity: "success" | "info" | "warn" | "error"; 
  summary: string; 
  detail: string; 
  life?: number; 
}

const Message: React.FC<MessageProps> = ({ open, severity, summary, detail, life = 5000 }) => {
  const toast = useRef<Toast>(null);

  useEffect(() => {
    if (open) {
      toast.current?.show({
        severity,
        summary,
        detail,
        life,
      });
    }
  }, [open, severity, summary, detail, life]);

  return <Toast ref={toast} />;
};

export default Message;
